import {
  CLEANUP_DISCOVER_REVIEWS,
  CLEANUP_DISCOVER_REVIEW_DETAILS,
  DELETE_DISCOVERY_REVIEW,
  DELETE_DISCOVERY_REVIEW_FAILED,
  DELETE_DISCOVERY_REVIEW_SUCCESS,
  GET_DISCOVERY_REVIEWS,
  GET_DISCOVERY_REVIEWS_FAILED,
  GET_DISCOVERY_REVIEWS_SUCCESS,
  GET_DISCOVERY_REVIEW_DETAILS,
  GET_DISCOVERY_REVIEW_DETAILS_FAILED,
  GET_DISCOVERY_REVIEW_DETAILS_SUCCESS,
} from './actionTypes';

// actionGetDiscoveryReviews
export const actionGetDiscoveryReviews = (payload) => ({
  payload,
  type: GET_DISCOVERY_REVIEWS,
});

export const actionGetDiscoveryReviewsSuccess = (payload) => ({
  payload,
  type: GET_DISCOVERY_REVIEWS_SUCCESS,
});

export const actionGetDiscoveryReviewsFailed = () => ({
  type: GET_DISCOVERY_REVIEWS_FAILED,
});

export const actionCleanupDiscoverReviews = () => ({
  type: CLEANUP_DISCOVER_REVIEWS,
});

// actionGetDiscoveryReviewsDetails
export const actionGetDiscoveryReviewDetails = (payload) => ({
  payload,
  type: GET_DISCOVERY_REVIEW_DETAILS,
});

export const actionGetDiscoveryReviewDetailsSuccess = (payload) => ({
  payload,
  type: GET_DISCOVERY_REVIEW_DETAILS_SUCCESS,
});

export const actionGetDiscoveryReviewDetailsFailed = () => ({
  type: GET_DISCOVERY_REVIEW_DETAILS_FAILED,
});

export const actionCleanupDiscoverReviewDetails = () => ({
  type: CLEANUP_DISCOVER_REVIEW_DETAILS,
});

// actionDeleteDiscoveryReview
export const actionDeleteDiscoveryReview = (payload) => ({
  payload,
  type: DELETE_DISCOVERY_REVIEW,
});

export const actionDeleteDiscoveryReviewSuccess = (payload) => ({
  payload,
  type: DELETE_DISCOVERY_REVIEW_SUCCESS,
});

export const actionDeleteDiscoveryReviewFailed = () => ({
  type: DELETE_DISCOVERY_REVIEW_FAILED,
});
